import Router from 'src/routes/router'
import routes from 'src/routes/definitions'
import { TextLinkProps } from 'src/components/A'

import { BreadcrumbProps } from '../../components/Breadcrumb'

export const breadcrumbTransformer = (args: {
  bgColor?: string
  t: (key: string) => string
  lastItems: TextLinkProps[]
  accountUrl?: string | null
  hasFamItem?: boolean
  isFromHebdo?: boolean
  hasMoveItem?: boolean
}): BreadcrumbProps => {
  const {
    bgColor,
    t,
    lastItems = [],
    accountUrl = false,
    hasFamItem = true,
    hasMoveItem = false,
    isFromHebdo,
  } = args
  const famItem = hasFamItem
    ? [
        {
          href: lastItems.length
            ? Router.getRouteUrl(routes.planning.name)
            : null,
          text: t('breadcrumb_fam'),
        },
      ]
    : isFromHebdo
    ? [
        {
          href: lastItems.length ? Router.getRouteUrl(routes.hebdo.name) : null,
          text: t('breadcrumb_hebdo'),
        },
      ]
    : []

  const secondItem = !hasMoveItem
    ? accountUrl
      ? {
          text: t('breadcrumb_my_account'),
          href: accountUrl,
        }
      : {
          href: t('breadcrumb_eat_better_url'),
          text: t('breadcrumb_eat_better'),
        }
    : {
        href: t('breadcrumb_move_url'),
        text: t('breadcrumb_move'),
      }

  const defaultLinks = [
    {
      href: t('breadcrumb_home_url'),
      text: t('breadcrumb_home'),
    },
    secondItem,
    ...famItem,
  ]
  return {
    bgColor,
    links: [...defaultLinks, ...lastItems],
  }
}
